import React, { useState } from 'react';
import './ContactUs.css';

function ContactUs() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [reason, setReason] = useState('');
    const [status, setStatus] = useState('');
    const [loading, setLoading] = useState(false);

    const handleNameChange = (event) => {
        setName(event.target.value);
    };
    
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };
    
    const handleReasonChange = (event) => {
        setReason(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoading(true);
        setStatus('');
        
        fetch('/api/email/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                name: name,
                email: email,
                message: reason,
            })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            setStatus('Message sent successfully!');
            // Clear form
            setName('');
            setEmail('');
            setReason('');
        })
        .catch(error => {
            setStatus('Failed to send message. Please try again.');
        })
        .finally(() => {
            setLoading(false);
        });
    };

    return (
        <form onSubmit={handleSubmit} className="contactUs">
            <hr/>
            <h1>Contact Us</h1>
            
            {status && <div className={status.includes('success') ? 'success-message' : 'error-message'}>{status}</div>}
            
            <label>
                Name:
                <input 
                    type="text" 
                    className="smallbox" 
                    value={name} 
                    onChange={handleNameChange}
                    required 
                />
            </label>
            <br />
            <label>
                Email:
                <input 
                    type="email" 
                    value={email} 
                    onChange={handleEmailChange}
                    required 
                />
            </label>
            <br />
            <label>
                Description of the reason for reaching out:
                <br />
                <textarea 
                    value={reason} 
                    onChange={handleReasonChange}
                    required 
                />
            </label>
            <br />
            <button type="submit" disabled={loading}>
                {loading ? 'Sending...' : 'Submit'}
            </button>
        </form>
    );
}

export default ContactUs;